import React, { HTMLAttributes } from 'react';

import { View } from '@uncinc/react-drupal-core';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import { GenericParagraphEntity } from '../../../types/uncinc_profile/paragraphs';

interface ParagraphFaqThemesProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<GenericParagraphEntity>;
}

const ParagraphFaqThemes: React.FC<ParagraphFaqThemesProps> = (props) => {
  const { entity } = props;

  const paragraph = entity.toJS();
  const uuid = paragraph.uuid[0].value;

  return (
    <div id={uuid} className="ParagraphFaqThemes">
      <Container>
        <View
          id="faq"
          display="default"
        />
      </Container>
    </div>
  );
};

export default ParagraphFaqThemes;
